import s from './SmallCard.module.css'
import { Avatar, Image, Space, Button, Modal } from 'antd'
import { getFilePath } from '@helpers/new/getFilePath'
import noPhoto from '../../../images/noPhoto.png'
import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import ProfileCardContainer from '../ProfileCard/ProfileCardContainer'
import EditEntityModal from '@modals/EditEntityModal/EditEntityModal'
import { useSelector } from 'react-redux'
import { selectProfile } from '@store/profile.reducer'
import { hasStudentProfileVisibleFieldsForRole } from '@/helpers/studentProfileFields'
import { profileFieldsApi } from '@/api'
import {
  PROFILE_FIELD_ENTITY_TYPES,
  getProfileFieldsResponseData,
} from '@/helpers/profileFields'

const SmallCard = ({
  img = null,
  text = '',
  title = '',
  subtitle = '',
  onClickTitle = null,
  profile = null,
  hideModal = false,
  profileType = 'legacy',
  profileModalClassNames,
  profileModalZIndex,
  ...props
}) => {
  return <Space {...props}>
    <Avatar
      className={s.avatar}
      src={<Image src={getFilePath(img ?? noPhoto)} />}
      size='large'
    />
    <div>
      <div className={s.text}>{text}</div>
      {onClickTitle
        ? <ButtonTitle {...{onClickTitle, title}} />
        : profile
          ? <ProfileTitle {...{ profile, title, hideModal, profileType, profileModalClassNames, profileModalZIndex }} />
          : <Title {...{ title }} />
      }
      {!!subtitle && <div className={s.subtitle}>{subtitle}</div>}

    </div>

  </Space>
}

export default SmallCard

const Title = ({ title }) => <h3 className={s.title}>{title}</h3>

const ButtonTitle = ({ onClickTitle, title }) => <Button type="text" onClick={onClickTitle} className={s.button}><Title {...{ title }} /></Button>

const ProfileTitle = ({ profile, title, hideModal, profileType, profileModalClassNames, profileModalZIndex }) => {
  const [open, setOpen] = useState(false)

  if (profileType === 'student') {
    return <StudentProfileTitle {...{profile, title, hideModal, open, setOpen, profileModalClassNames, profileModalZIndex}} />
  }

  if (profileType === 'parent') {
    return <ParentProfileTitle {...{profile, title, hideModal, open, setOpen, profileModalClassNames, profileModalZIndex}} />
  }

  if (profileType === 'employee') {
    return <EmployeeProfileTitle {...{profile, title, hideModal, open, setOpen, profileModalClassNames, profileModalZIndex}} />
  }

  return <>
    <ButtonTitle {...{onClickTitle: ()=>setOpen(hideModal ? false : true), title}} />
    <Modal centered footer={[]} zIndex={profileModalZIndex} {...{open, onCancel: ()=>setOpen(false),  width:1000}} >
     <ProfileCardContainer userId={profile} type='edit' hideEditMode />
    </Modal>
  </>
}

const ParentProfileTitle = ({ profile, title, hideModal, open, setOpen, profileModalClassNames, profileModalZIndex }) => {
  const modal = (
    <EditEntityModal
      type="parent"
      open={open}
      parentId={profile}
      onDismiss={() => setOpen(false)}
      onUpdate={() => setOpen(false)}
      classNames={profileModalClassNames}
      zIndex={profileModalZIndex}
    />
  )

  return <>
    <ButtonTitle {...{onClickTitle: ()=>setOpen(hideModal ? false : true), title}} />
    {profileModalZIndex && typeof document !== 'undefined'
      ? createPortal(modal, document.body)
      : modal}
  </>
}

const EmployeeProfileTitle = ({ profile, title, hideModal, open, setOpen, profileModalClassNames, profileModalZIndex }) => {
  const modal = (
    <EditEntityModal
      type="employee"
      open={open}
      employeeId={profile}
      onDismiss={() => setOpen(false)}
      onUpdate={() => setOpen(false)}
      classNames={profileModalClassNames}
      zIndex={profileModalZIndex}
    />
  )

  return <>
    <ButtonTitle {...{onClickTitle: ()=>setOpen(hideModal ? false : true), title}} />
    {profileModalZIndex && typeof document !== 'undefined'
      ? createPortal(modal, document.body)
      : modal}
  </>
}

const StudentProfileTitle = ({ profile, title, hideModal, open, setOpen, profileModalClassNames, profileModalZIndex }) => {
  const profileData = useSelector(selectProfile)
  const platformSettings = useSelector((store) => store.settings)
  const [profileApiFields, setProfileApiFields] = useState([])

  useEffect(() => {
    profileFieldsApi
      .index({ entity_type: PROFILE_FIELD_ENTITY_TYPES.STUDENT })
      .then((response) => setProfileApiFields(getProfileFieldsResponseData(response)))
      .catch(() => setProfileApiFields([]))
  }, [])

  const canOpenStudentCard = hasStudentProfileVisibleFieldsForRole(
    platformSettings,
    profileData?.role,
    profileApiFields,
  )
  const modal = (
    <EditEntityModal
      type="student"
      open={open}
      studentId={profile}
      onDismiss={() => setOpen(false)}
      onUpdate={() => setOpen(false)}
      classNames={profileModalClassNames}
      zIndex={profileModalZIndex}
    />
  )

  return <>
    <ButtonTitle {...{onClickTitle: ()=>setOpen(hideModal || !canOpenStudentCard ? false : true), title}} />
    {profileModalZIndex && typeof document !== 'undefined'
      ? createPortal(modal, document.body)
      : modal}
  </>
}
